import { FC } from "react";
import { Styled } from "../types";

const PAGE_HEADER_STYLES = "text-primary text-3xl font-semibold";

export const TitleWithStyles: FC<Styled & { title: string }> = ({
  title,
  className = "",
}) => {
  return (
    <>
      <title>{title}</title>
      <h1 className={`${PAGE_HEADER_STYLES} ${className}`}>{title}</h1>
    </>
  );
};
